/**
 * Pilha de navegação interna do app.
 * Variável de módulo: reseta ao recarregar a página (comportamento consistente),
 * mas persiste entre re-renders e re-renders do header.
 */
const _stack: string[] = [];

export const navigationStack = {
  push(path: string) {
    if (_stack[_stack.length - 1] !== path) {
      _stack.push(path);
    }
  },

  /** Existe pelo menos uma rota anterior dentro do app? */
  canGoBack(): boolean {
    return _stack.length > 1;
  },

  /** Remove a rota atual e retorna a anterior (ou /overview como fallback). */
  pop(): string {
    _stack.pop();
    return _stack[_stack.length - 1] ?? "/overview";
  },
};
